import { Socket, SocketIoConfig } from 'ngx-socket-io';
import { ApplicationRef, Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable()
export class SyncService {
    private socket!: Socket;
    isSynchronized: boolean = false;

    constructor(private readonly appRef: ApplicationRef) {
        this.initSocket();
        this.initSocketEvents();
    }

    private initSocket() {
        const socketConfig = this.getSocketConfig();
        this.socket = new Socket(socketConfig as SocketIoConfig, this.appRef);
    }

    private initSocketEvents() {
        this.socket.on('connect', () => {
            this.isSynchronized = true;
        });

        this.socket.on('disconnect', () => {
            this.isSynchronized = false;
        });
    }

    private getSocketConfig() {
        const socketConfig: any = {
            options: {
                reconnectionAttempts: 20
            }
        };

        const apiUrl = environment.ZONAR_API_URL;
        socketConfig.url = this.getSocketUrlOrigin(apiUrl);
        return socketConfig;
    }

    private getSocketUrlOrigin(apiUrl: string): string {
        const fallbackOrigin = window.location.origin;

        if (!apiUrl) {
            return fallbackOrigin;
        }

        try {
            // Handles absolute URLs and protocol-relative URLs.
            return new URL(apiUrl).origin;
        } catch {
            try {
                // Handles relative URLs like "/api" or "api".
                return new URL(apiUrl, fallbackOrigin).origin;
            } catch {
                return fallbackOrigin;
            }
        }
    }

    initEventHandler(eventName: string, handler: any) {
        if (!eventName || !handler) {
            return;
        }
        this.socket.on(eventName, handler);
    }
}
